import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Slider, { Settings } from 'react-slick';

const RewardCategory = ({ rewardsCategoryList, arrows }) => {
    const history = useHistory();

    const handleCategoryClick = (id) => {
        history.push(`/rewardStore?rewardCategoryId=${id}`);
    };

    var settings = {
        dots: false,
        arrows: arrows || true,
        infinite: true,
        vertical: false,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: 'linear',
        pauseOnHover: true,
        className: '',
        variableWidth: true
    };
    return (
        <div id="RewardCategories" className="w-full">
            <h2 className="font-bold text-[#130E2F] text-[20px] text-center w-full mb-8">
                Explore our Categories
            </h2>
            <div className="overflow-x-scroll overflow-x-hidden scrollbar-thin w-full mx-auto ">
                <Slider {...settings}>
                    {' '}
                    {rewardsCategoryList?.map((item) => (
                        <div
                            key={item.id}
                            className="flex flex-col items-center text-center mr-5 cursor-pointer"
                            onClick={() => handleCategoryClick(item.id)}
                        >
                            <img
                                src={item?.bannerUrl}
                                className="h-[93px] w-[114px] lg:w-[181px] lg:h-[149px]"
                            />
                            <span className="mt-4 text-[#130E2F] font-medium text-[13px] lg:text-[17px] text-center">
                                {item?.name}
                            </span>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default RewardCategory;
